module.exports = __webpack_public_path__ + "media/images/global/icons/signboard-a5c697e89545e4354f0782ce55b7f772.svg";